<div class="fixed top-0 left-0 w-full page-wrapper">
  <div class="login-container">
  <!-- Skip to content link for accessibility -->
    <a href="#login-form" class="skip-to-content" tabindex="0">{{ 'login.skipToForm' | translate }}</a>

    <div class="login-lang-switch">
      <app-language-switcher></app-language-switcher>
    </div>

    <div class="login-card" [class.login-card-loading]="isLoading">
    <img class="logo" src="assets/logo.png" alt="Axede Logo" />
      <h1>{{ 'login.title' | translate }}</h1>

      <form (ngSubmit)="onSubmit()" [formGroup]="loginForm" role="form" id="login-form" aria-labelledby="login-heading">

      <!-- Email field with reserved validation space -->
        <div class="form-group" [class.focused]="fieldStates['email'].focused" [class.error]="hasFieldError('email')">
          <div class="floating-label">
            <input
              #emailInput
              id="email"
              type="email"
              formControlName="email"
              placeholder=" "
              aria-describedby="email-error"
              autocomplete="email"
              (focus)="onFieldFocus('email')"
              (blur)="onFieldBlur('email')"
              [attr.aria-invalid]="hasFieldError('email')"
            />
            <label for="email" [class.field-active]="fieldStates['email'].focused || !!loginForm.get('email')?.value">
              {{ 'login.email.label' | translate }}
            </label>
          </div>

          <div class="validation-message-container">
            <div
              id="email-error"
              class="error-message"
              [class.visible]="hasFieldError('email')"
              role="alert"
            >
              {{ hasFieldError('email') ? getEmailErrorMessage() : '' }}
            </div>
          </div>
        </div>

      <!-- Password field with reserved validation space -->
      <div class="form-group" [class.focused]="fieldStates['password'].focused" [class.error]="hasFieldError('password')">
          <div class="floating-label">
            <input
              id="password"
              [type]="showPassword ? 'text' : 'password'"
              formControlName="password"
              placeholder=" "
              aria-describedby="password-error"
              autocomplete="current-password"
              (focus)="onFieldFocus('password')"
              (blur)="onFieldBlur('password')"
              [attr.aria-invalid]="hasFieldError('password')"
            />
            <label for="password" [class.field-active]="fieldStates['password'].focused || !!loginForm.get('password')?.value">
              {{ 'login.password.label' | translate }}
            </label>

            <button
              type="button"
              class="toggle-password"
              (click)="togglePasswordVisibility()"
              [attr.aria-label]="(showPassword ? 'login.password.hide' : 'login.password.show') | translate"
              [attr.aria-pressed]="showPassword"
            >
              <i [class]="showPassword ? 'pi pi-eye-slash' : 'pi pi-eye'"></i>
            </button>
          </div>

          <div class="validation-message-container">
            <div
              id="password-error"
              class="error-message"
              [class.visible]="hasFieldError('password')"
              role="alert"
            >
              {{ hasFieldError('password') ? getPasswordErrorMessage() : '' }}
            </div>
          </div>
        </div>

      <!-- TODO: Implement a system to allocate the auth state in session or storage -->
      <!-- Remember me checkbox
      <div class="remember-me">
        <div class="custom-checkbox">
          <input type="checkbox" id="rememberMe" formControlName="rememberMe" />
          <label for="rememberMe" class="checkbox-label">
            <span class="checkbox-icon"></span>
            <span class="checkbox-text">Recordar mi correo</span>
          </label>
        </div>
      </div> -->


        <app-turnstile
          *ngIf="!disableTurnstile"
          [siteKey]="turnstileSiteKey"
          action="login"
          [theme]="'dark'"
          (resolved)="onTurnstileResolved($event)">
        </app-turnstile>

        <!-- Submit button -->
        <button
          type="submit"
          class="login-btn"
          [disabled]="isLoading"
          [attr.aria-busy]="isLoading"
          [class.loading]="isLoading"
        >
          <span class="btn-content" [class.hidden]="isLoading">{{ 'login.submit' | translate }}</span>
          <span class="loader" *ngIf="isLoading" aria-hidden="true">
            <i class="pi pi-spin pi-spinner"></i>
          </span>
        </button>

      <!-- Login links section -->
      <!-- <div class="login-links">
        <a href="#" class="forgot-password" tabindex="0">¿Olvidó su contraseña?</a>
      </div> -->
      </form>

    <!-- Loading overlay -->
      <div class="loading-overlay" *ngIf="isLoading" aria-live="polite" aria-atomic="true">
        <p-progressSpinner styleClass="w-4rem h-4rem" strokeWidth="4" fill="var(--surface-ground)" animationDuration=".5s" [attr.aria-label]="'login.loading' | translate"></p-progressSpinner>
        <p class="loading-message">{{ 'login.processing' | translate }}</p>
      </div>
    </div>
  </div>

</div>

<!-- Toast message container -->
<p-toast position="top-right"></p-toast>

<!-- Unverified user dialog -->
<p-dialog
  [header]="'login.unverified.header' | translate"
  [(visible)]="showResendDialog"
  [modal]="true"
  [style]="{width: '450px'}"
  [draggable]="false"
  [resizable]="false"
  aria-labelledby="unverified-dialog-title"
  role="alertdialog"
>
  <div class="dialog-dark-overlay">
    <div class="dialog-content">
      <p>{{ 'login.unverified.message' | translate }}</p>
      <div class="dialog-email">{{unverifiedEmail}}</div>
    </div>
  </div>
  <ng-template pTemplate="footer">
    <div class="dialog-footer-overlay">
      <button pButton pRipple [label]="'login.cancel' | translate" icon="pi pi-times" class="p-button-text" (click)="showResendDialog = false"></button>
      <button pButton pRipple [label]="'login.unverified.resend' | translate" icon="pi pi-envelope" class="p-button-primary" (click)="resendVerification()" [loading]="isResending"></button>
    </div>
  </ng-template>
</p-dialog>

<!-- Session conflict dialog -->
<p-dialog
  [header]="'login.sessionConflict.header' | translate"
  [(visible)]="showSessionConflictDialog"
  [modal]="true"
  [style]="{width: '500px'}"
  [draggable]="false"
  [resizable]="false"
  [closable]="!isCleaningUserData"
  aria-labelledby="session-conflict-dialog-title"
  role="alertdialog"
>
  <div class="dialog-dark-overlay session-conflict-overlay">
    <div class="dialog-content">
      <div class="session-conflict-icon">
        <i class="pi pi-exclamation-triangle" style="font-size: 3rem; color: var(--orange-500);"></i>
      </div>
      <p class="session-conflict-message">
        {{ 'login.sessionConflict.message' | translate }}
      </p>

    </div>
  </div>
  <ng-template pTemplate="footer">
    <div class="dialog-footer-overlay session-conflict-footer">
      <button
        pButton
        pRipple
        [label]="'login.cancel' | translate"
        icon="pi pi-times"
        class="p-button-text"
        (click)="cancelSessionConflict()"
        [disabled]="isCleaningUserData"
      ></button>
      <button
        pButton
        pRipple
        [label]="'login.sessionConflict.logoutOther' | translate"
        icon="pi pi-sign-out"
        class="p-button-danger"
        (click)="cleanUserDataAndLogin()"
        [loading]="isCleaningUserData"
      ></button>
    </div>
  </ng-template>
</p-dialog>
